import React from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import AnswersList from './AnswersList';
import LocPageFooter from './PageFooter';

function LocAnswersColumbia() {
  // <BuildBootStrapMenu />
  const parkingType = (
    <ul style={{ marginBottom: 1 }}>
      <li>
        Daytime Commuter: 24 hour / 7 day access. Must exit after work shift
        ends.
      </li>
      <li>
        Nights & Weekends Commuter: Entry M–F after 2:30 p.m. on weekdays. On
        weekends and observed NYP holidays.
      </li>
      <li>Storage Parking: Storage parking not allowed.</li>
    </ul>
  );

  const waitingList =
    'No waiting list. New applicants are assigned to Allen Hospital Crescent Lot.';

  const campusName = 'Columbia University Irving Medical Campus (CUIMC)';
  const campusContact = 'parkingnyp-west@nyp.org';
  const carStorage = 'No. Storage parking not allowed.';
  const telNum = '212-305-4903 or 212-305-2718';
  const eligible = 'and Columbia University Medical';

  return (
    <div style={{ marginBottom: 20 }}>
      <LocPageFooter
        title={`For answers related to NYP ${campusName} parking locations, 
          please click on the questions below.`}
      />
      <AnswersList
        parkType={parkingType}
        waitList={waitingList}
        campus={campusName}
        contact={campusContact}
        storage={carStorage}
        tel={telNum}
        eligibleGrp={eligible}
      />
    </div>
  );
}

export default LocAnswersColumbia;
